// extracted by mini-css-extract-plugin
module.exports = {"button":"vendorMenu_button__RSpvK","activeMenu":"vendorMenu_activeMenu__N7r2P","menu":"vendorMenu_menu__f0Y_f"};